<template>
  <div class="card-padding">
    <div class="top">
      <div class="left">
        <div class="header-common view-flex view-flex-bottom">
          <div class="main">
            月度客户分析
          </div>
        </div>
        <div class="header-common view-flex view-flex-bottom">
          <div class="subtitle">
            当月累计到当月前一日客户相关数据
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <el-select v-model="value" placeholder="按渠道分析">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>
    </div>

    <br>
    <div class="mid">
      <div class="body view-flex">
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>新增客户数&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月添加新客好友数（数据库从未录入且非云店会员）
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ (topData && topData.new_user) || 0 }}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>新增会员数&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月通过导购注册会员数
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ (topData && topData.login_user) || 0 }}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay last">
            <div class="moneyValue">
              <div class="symbol">
                <span>实付会员数&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月实付下单的会员数
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ (topData && topData.pay_user) || 0 }}
            </div>
          </div>
        </div>
        <!-- <div class="col">
          <div class="labelDisplay last">
            <div class="moneyValue">
              <div class="symbol">
                <span>流失客户数&nbsp;</span>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    <div class="tip-content">
                      当月删除导购好友关系并未与其他导购为好友关系的客户数
                    </div>
                  </div>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ (topData && topData.outflow_user) || 0 }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <br>
    <el-row>
      <div id="container3" />
    </el-row>
  </div>
</template>

<script>
import { Chart } from '@antv/g2'
export default {
  data () {
    return {
      options: [
        {
          value: '员工',
          label: '员工'
        },
        {
          value: '公众号',
          label: '公众号'
        },
        {
          value: '商城',
          label: '商城'
        },
        {
          value: '导购',
          label: '导购'
        }
      ],
      value: '',
      area: null,
      customerAnalysisData: [],
      topData: {}
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    money (num) {
      return ` ${(num / 100).toFixed(2)}`
    },
    async fetch () {
      const data3 = await this.$api.dashboard.getCustomerAnalysis({})
      if (data3) {
        this.topData = data3.data
        data3.list.map((v) => {
          this.customerAnalysisData.push({
            statistic_date: v.statistic_date,
            value: v.new_user,
            type: '新增客户'
          })
          this.customerAnalysisData.push({
            statistic_date: v.statistic_date,
            value: v.login_user,
            type: '新增会员'
          })
          this.customerAnalysisData.push({
            statistic_date: v.statistic_date,
            value: v.pay_user,
            type: '实付会员'
          })
        })
        this.draw()
      }
    },
    draw () {
      if (this.chart) {
        this.chart.update({
          data: this.customerAnalysisData
          // angleField: 'value',
          // colorField: 'type',
          // height: 180
        })
      } else {
        this.chart = new Chart({
          container: 'container3',
          autoFit: true,
          height: 360
        })

        this.chart.data(this.customerAnalysisData)
        this.chart.scale('statistic_date', {
          type: 'linear',
          tickInterval: 1
        })
        this.chart.scale('login_user', {
          alias: '本月'
        })

        this.chart.tooltip({
          showCrosshairs: true,
          shared: true
        })

        this.chart.legend({
          custom: true,
          items: [
            {
              value: '新增客户',
              name: '新增客户',
              marker: { symbol: 'square', style: { fill: '#429CF9', r: 5 } }
            },
            {
              value: '新增会员',
              name: '新增会员',
              marker: { symbol: 'square', style: { fill: '#57D59F', r: 5 } }
            },
            {
              value: '实付会员',
              name: '实付会员',
              marker: { symbol: 'square', style: { fill: '#5e7191', r: 5 } }
            }
          ]
        })

        this.chart.area().position('statistic_date*value').color('type')
        this.chart.line().position('statistic_date*value').color('type')
        this.chart.interaction('element-highlight')
        this.chart.render()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  .body {
    display: flex;
    padding: 10px;
    .col {
      width: 33.3333%;
      margin-top: 30px;
    }
  }

  &.height190px {
    height: 190px;
  }

  .header-common {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .subtitle {
      font-size: 12px;
      color: grey;
      cursor: pointer;
    }
  }
  &.histogram {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
.tip-content {
  max-width: 250px;
  line-height: 18px;
}
@media only screen and (max-width: 1600px) {
  .card-padding {
    padding-bottom: 30px;

    .body {
      display: flex;

      .col {
        margin-top: 20px;
      }
    }

    .header-common {
      .main {
        font-size: 14px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
  }
}
.top {
  display: flex;
  justify-content: space-between;
}

@mixin afterelement {
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: '';
    height: 340%;
    right: 10px;
    top: -15px;
    width: 1px;
    background: rgba(0, 0, 0, 0.1);
  }
}
@mixin clearafterelement {
  &:after {
    display: none;
  }
}
.labelDisplay {
  .num,
  .moneyValue {
    font-size: 24px;
    color: black;
  }
  .num {
    @include afterelement();
  }
  .label {
    font-size: 16px;
    color: #333;
  }
  .moneyValue {
    display: flex;
    align-items: flex-end;
    @include afterelement();

    .symbol {
      color: #9c9fa6;
      margin-right: 4px;
      font-size: 12px;
      position: relative;
      bottom: 4px;
    }
  }

  &.moneyLabel {
    .num {
      color: black;
    }
  }
  &.last {
    .num {
      @include clearafterelement();
    }
    .moneyValue {
      @include clearafterelement();
    }
  }
}
@media only screen and (max-width: 1600px) {
  .labelDisplay {
    .num,
    .moneyValue {
      font-size: 20px;
      color: black;
    }
    .label,
    .moneyLabel {
      font-size: 16px;
      color: #333;
    }

    .moneyValue {
      .symbol {
        color: #9c9fa6;
        margin-right: 4px;
        font-size: 12px;
        position: relative;
        bottom: 4px;
      }
    }
  }
}
</style>
